<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <b-container>
        <!-- <b-modal ref="my-modal" v-model="stateDetailVisible" ok-title="关闭" ok-only title="详情">
      <p v-for="item in stateDetailSelect">
        <span style="margin-right:20px">{{item.time}}</span>
        <b-badge variant="primary" v-if="item.sts == 0">提交审核</b-badge>
        <b-badge variant="danger" v-if="item.sts == 1">审核不通过</b-badge>
        <b-badge variant="secondary" v-if="item.sts == 2">审核通过</b-badge>
        <b-badge variant="primary" v-if="item.sts == 3">再次提交审核</b-badge>
      </p>
    </b-modal>-->

        <b-modal id="my-modal">上传成功</b-modal>

        <b-modal id="my-modal2">上传失败</b-modal>

        <b-modal v-model="showErrMsg">
            <div>{{ errMsg }}</div>
        </b-modal>

        <b-breadcrumb :items="bread" class="mt10"></b-breadcrumb>

        <b-alert show variant="info" class="mt20">
            <h4 class="alert-heading">普惠型首席科学家申请简表</h4>
            <!--<p>拟组织渤黄海航次（NORC2023-01)、东海航次（NORC2023-02)、长江口航次（NORC2023-03)、台湾海峡航次（NORC2023-04)、南海东北部-吕宋海峡综合航次（NORC2023-05)、南海中部海盆综合航次（NORC2023-06)、珠江口-南海西部综合航次（NORC2023-07)、南海地球物理航次（NORC2023-08)、西太平洋航次（NORC2023-09)、东印度洋航次（NORC2023-10)、北部湾航次（NORC2023-11)等11个普惠型科学考察航次</p>-->
            <div v-html="promptMsg"></div>
            <a style="font-size:18px;font-weight:bold; text-decoration: underline; color: #007bff;"
                href="/template/普惠型首席科学家申请简表.docx">点击下载《普惠型首席科学家申请简表模板》</a>
        </b-alert>

        <b-alert show variant="info" class="mt20">
            <p class="alert-heading">【特别提醒】项目申请书模板填写“报告正文”部分，后用于替换基金委系统中的正文部分，其余信息仍按照基金委系统填写。</p>
            <a style="font-size:18px;font-weight:bold;text-decoration: underline; color: #007bff;"
                href="/template/共享航次计划项目申请书填报注意事项及正文撰写提纲（2024年）.doc">点击下载《共享航次计划项目申请书填报注意事项及正文撰写提纲（2024年）》</a>
        </b-alert>

        <b-alert show variant="danger" v-if="applyId > 0">
            <h4 class="alert-heading">重新提交</h4>
            <p>文件名称：{{ item.fileName }}</p>
            <p>上次提交时间：{{ item.createTime }}</p>
            <a style="font-size:18px;" :href="item.fileName2">下载上次提交文件</a>
        </b-alert>

        <div style="background-color:#d1ecf1; padding:20px;">
            <b-form-group id="input-group-3" label-for="input-3" label="请选择一个航次：">
                <b-form-select v-model="selectCruiseInfo" :options="cruiseInfo" placeholder="请选择一个航次："
                    :state="cruiseNameState"></b-form-select>
            </b-form-group>

            <b-form-group label="首席科学家：">
                <b-form-input v-model="csName" :state="csNameState"></b-form-input>
            </b-form-group>
            <b-form-group>
                <template #label>
                    申请单位：
                    <span class="unit-name-fill-tip">请务必依据项目批准通知书中的依托单位写法填写本栏，否则搭载无效</span>
                </template>
                <unitname-auto-complete @select="getUnitName" :init-value="unitName"
                    @onInput="getInputUnitName"></unitname-auto-complete>
            </b-form-group>


            <b-form-group>
                <b-badge variant="secondary">只允许上传pdf文件，大小10M以内</b-badge>
                <b-form-file v-model="file2" plain accept=".pdf" style="margin-top:10px" @input="uploadImgChange"
                    :disabled="expired"></b-form-file>
                <br/>

                <b-button size="sm" variant="outline-primary" style="margin-top:10px" @click="startUpload"
                    :disabled="expired">开始上传</b-button>
            </b-form-group>

        </div>

        <link-component></link-component>
    </b-container>
</template>

<script>
import LinkComponent from '../../components/LinkComponent.vue';
import Vue from 'vue';
import { axiosServer } from '@/api/judge';
import { urls } from '@/api/urls';
import { requestCsApply, requestCsApplyQuest, requestApplyYears } from '@/api/SvpConfig';
import axios from '@/api/axios';
import UnitnameAutoComplete from '@/components/UnitnameAutoComplete.vue'

export default {
    components: { LinkComponent, UnitnameAutoComplete },
    name: 'ChiefScientistExplain',
    props: {},
    computed: {
        cruiseNameState() {
            return this.selectCruiseInfo ? true : false;
        },
        csNameState() {
            return this.csName ? true : false;
        },
    },
    data() {
        return {
            selectCruiseInfo: "",
            cruiseInfo: [],
            uploadProgress: 0,
            reqBody: { page: 1, pageSize: 10, cruiseYear: null },
            applyId: this.$route.query.applyId,
            years: [
                { value: null, text: '全部年份' },
                { value: '2025', text: '2025' },
                { value: '2024', text: '2024' },
                { value: '2023', text: '2023' },
                { value: '2022', text: '2022' },
                { value: '2021', text: '2021' },
                { value: '2020', text: '2020' },
                { value: '2019', text: '2019' },
                { value: '2018', text: '2018' },
                { value: '2017', text: '2017' },
                { value: '2016', text: '2016' },
                { value: '2015', text: '2015' },
            ],
            stateDetailSelect: {},
            stateDetailVisible: false,
            fields: [
                { key: 'id', label: '申请号' },
                { key: 'fileName', label: '申请书' },
                { key: 'createTime', label: '提交时间' },
            ],
            bread: [
                {
                    text: '首页',
                    href: '/index',
                },
                {
                    text: '首席科学家申请',
                    href: '/ChiefScientistExplain',
                },
                {
                    text: '重大科学技术问题研究科学考察项目首席科学家申请',
                },
            ],
            promptMsg: '',
            promptMsg2: '',
            expired: false,
            items: [],
            pagination: {},
            loading: true,
            keyword: '',
            selectFile: null,
            file2: null,
            item: {},
            // 首席科学家
            csName: null,
            // 单位            
            unitName: null,
            unitNameId: null,
            showErrMsg: false,
            errMsg: '',
        };
    },
    activated() {
        const _this = this
        const applyId = this.$route.query.applyId;

        this.checkLogin();
        requestCsApply().then((resp) => {
            this.promptMsg = resp.desc1;
            this.expired = resp.expired;
        });

        console.log(applyId)

        if (applyId) {
            //获取需要修改的值
            axiosServer({
                url: '/SvpCsApply/' + applyId,
                type: 'get',
            })
                .then((resp) => {
                    _this.loading = false;
                    _this.item = resp.data.entity;
                    _this.item.fileName2 = '/imp/' + _this.item.fileName;

                    _this.selectCruiseInfo = _this.item.cruiseNumber
                    _this.csName = _this.item.chiefScientist
                    _this.unitName = _this.item.tenderUnit
                })
                .catch((e) => {
                    _this.loading = false;
                });
        } else {
            this.selectCruiseInfo = null
            this.csName = null
            this.unitName = null
        };

        //获取可以供选择的航次
        requestApplyYears().then((resp) => {
            const years = resp.yearsOptions.map(item => item.year)
            if (years.length == 0) {
                return
            }

            const year = years[0]
            axiosServer({
                url: '/SvpCruiseInfo/crruent?CruiseYear=' + year,
                type: 'get'
            })
                .then((resp) => {
                    resp.data.page.list.forEach(item => {
                        this.cruiseInfo.push({ value: item.cruiseNumber, text: item.cruiseName + " " + item.cruiseNumber });
                    })
                })
                .catch((e) => {
                });
        });


    },
    mounted() {
        this.checkLogin();


    },
    methods: {
        showError(errMsg) {
            this.errMsg = errMsg;
            this.showErrMsg = true;
        },
        async unitNameIsExists() {
            const resp = await axiosServer({
                url: "/svpSupportedUnit/isExist?unitName=" + this.unitName,
                type: 'get',
            })

            return resp.data.isExist;
        },
        uploadImgChange(file) {
            this.uploadProgress = 0;
            this.selectFile = file;
        },

        startUpload() {
            if (!this.selectFile) {
                this.showError("请选择上传的文件");
                return;
            }
            this.uploadToSever(this.selectFile);
        },

        async uploadToSever(file) {
            console.log(file);
            let fileSizeK = file.size / 1024;
            if (fileSizeK > 1024 * 10) {
                this.promptVisible = true;
                return;
            }

            if (!this.selectCruiseInfo) {
                this.showError("请选择航次");
                return;
            }

            if (!this.csName) {
                this.showError("请输入首席科学家");
                return;
            }

            const unitNameIsExists = this.unitName != null && this.unitName.length > 0
            if (!unitNameIsExists) {
                this.showError("请选择申请单位");
                return;
            }

            let param = new FormData(); // 创建form对象
            param.append('fileName', file); // 通过append向form对象添加数据
            param.append('chunk', '0'); // 添加form表单中其他数据
            param.append('type', '1')
            param.append('applyId', (this.applyId || 0))
            param.append('cruiseNumber', this.selectCruiseInfo)
            param.append('tenderUnit', this.unitName)
            param.append('chiefScientist', this.csName)

            const url = process.env.NODE_ENV == 'development' ? '/proxyApi/SvpUpload/imp' : '/SvpUpload/imp'

            const resp = await axios
                .post(
                    // process.env.NODE_ENV == 'development'
                    //     ? '/proxyApi/SvpUpload/imp?applyId=' + (this.applyId || 0) + '&type=1' + '&cruiseNumber=' + this.selectCruiseInfo
                    //     : '/SvpUpload/imp?applyId=' + (this.applyId || 0) + '&type=1' + '&cruiseNumber=' + this.selectCruiseInfo,
                    url,
                    param,
                    {
                        header: {
                            'Content-Type': 'multipart/form-data',
                        },
                        onUploadProgress: (progressEvent) => {
                            let complete = (((progressEvent.loaded / progressEvent.total) * 100) | 0) + '%';
                            this.uploadProgress = complete;
                        },
                    }
                )

            if (resp.data.code == 0) {
                this.$bvModal.show('my-modal');
                this.selectFile = null;
                this.file2 = null;
                this.$router.push({ name: 'ChiefScientistExplain' });
            } else {
                this.$bvModal.show('my-modal2');
            }
        },

        applyPdf(item) {
            let routeUrl = this.$router.resolve({
                path: '/CsApplyPdf',
                query: { applyId: item.applyId },
            });
            window.open(routeUrl.href, '_blank', 'width=1186px,height=832px,top=0px,left=0px');
        },
        showStateDetail(data) {
            this.stateDetailSelect = JSON.parse(data.item.statusTime);
            this.stateDetailVisible = true;
        },
        goDetail(code, data) {
            this.$router.push({ name: 'ChiefScientistForm', query: { code: code, applyId: data.applyId } });
        },
        checkLogin() {
            let loginName = Vue.ls.get('token');
            if (!loginName) {
                this.$router.push({
                    name: 'login',
                    query: { tip: 1, msg: '访问搭载需求征集页面需要先登录', redirectUrl: 'ChiefScientistExplain' },
                });
            }
        },
        toForm() {
            this.$router.push({ name: 'ChiefScientistForm' });
        },
        getUnitName(obj) {
            this.unitName = obj.unitName;
        },
        getInputUnitName(value) {
            console.log("getInputUnitNamev", value)
            this.unitName = value;
        }
    }
};
</script>

<style scoped>
.opButton {
    padding: 2px;
    width: 65px;
    margin-left: 5px;
    margin-top: 5px;
}

.unit-name-fill-tip {
    color: red;
    font-weight: 700;
}

.proj-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 300px;
    padding: 0px;
    margin-bottom: 0px;
}

/* 响应式布局：方案不同屏幕尺寸分别使用不同的CSS样式 */
@media (max-width: 575.99px) {
    .form-style {
        text-align: left;
        width: 100%;
    }

    .botton-row {
        margin-bottom: 20px;
    }
}

@media (min-width: 576px) {
    .form-style {
        text-align: left;
        width: 100%;
    }

    .botton-row {
        margin-bottom: 20px;
    }
}

@media (min-width: 768px) {
    .form-style {
        text-align: left;
        width: 70%;
        margin: 0 auto;
    }

    .botton-row {
        margin-bottom: 20px;
        padding: 0 50px;
    }
}

@media (min-width: 992px) {
    .form-style {
        text-align: left;
        width: 70%;
        margin: 0 auto;
    }

    .botton-row {
        margin-bottom: 20px;
        padding: 0 100px;
    }
}

@media (min-width: 1200px) {
    .form-style {
        text-align: left;
        width: 70%;
        margin: 0 auto;
    }

    .botton-row {
        margin-bottom: 20px;
        padding: 0 200px;
    }
}
</style>
